import React from "react";
import { Header } from "@/components/livon/Header";
import { Hero } from "@/components/livon/Hero";
import { WhatIsLivon } from "@/components/livon/WhatIsLivon";
import { ThreePlanes } from "@/components/livon/ThreePlanes";
import { Offerings } from "@/components/livon/Offerings";
import { About } from "@/components/livon/About";
import { Footer } from "@/components/livon/Footer";
import { useLenis } from "@/hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";

export default function LivonLanding() {
  useLenis();
  return (
    <div className="bg-livon-bg text-livon-forest min-h-screen" data-testid="livon-landing">
      <Header />
      <main>
        <Hero />
        <WhatIsLivon />
        <ThreePlanes />
        <Offerings />
        <About />
      </main>
      <Footer />
      <Toaster position="bottom-center" />
    </div>
  );
}
